export const BestandView4Headers = [
    {
        id: 1,
        title: 'Firma Kurz',
        mouseOver: '',
    },
    {
        id: 2,
        title: 'Firma',
        mouseOver: '',
    },
    {
        id: 3,
        title: 'MA',
        mouseOver: '',
    },
    {
        id: 4,
        title: 'Zust. FKB',
        mouseOver: '',
    },
    {
        id: 5,
        title: 'KBD',
        mouseOver: '',
    },
    {
        id: 6,
        title: 'KFD',
        mouseOver: '',
    },
    {
        id: 7,
        title: 'DGAPI KAM',
        mouseOver: '',
    },
    {
        id: 8,
        title: 'Auftr. DL-P',
        mouseOver: 'Auftrag an AMS zum DL-Paket',
    },
    {
        id: 9,
        title: 'DL+KA >',
        mouseOver: 'DL+Kanzleiauftrag versandt',
    },
    {
        id: 10,
        title: 'DL+KA <',
        mouseOver: 'DL+Kanzleiauftrag von Kunde zurück',
    },
    {
        id: 11,
        title: 'FP-Grdl. abg.',
        mouseOver: 'Projektgrundlagen abgeschlossen',
    },
    {
        id: 12,
        title: 'FP-Def vollst.',
        mouseOver: 'Projektdefintion vollständig',
    },
    {
        id: 13,
        title: 'CIB abg.',
        mouseOver: 'CIB abgeschlossen',
    },
    {
        id: 14,
        title: 'FP-Feischltg.',
        mouseOver: 'Projekt Freischaltung',
    },
    {
        id: 15,
        title: 'Bemerk',
        mouseOver: 'Bemerkung'
    },
]

export const BestandView4HeadersDgg = [
    {
        id: 1,
        title: 'Firma Kurz',
        mouseOver: '',
    },
    {
        id: 2,
        title: 'Firma',
        mouseOver: '',
    },
    {
        id: 3,
        title: 'MA',
        mouseOver: '',
    },
    {
        id: 4,
        title: 'Zust. CL',
        mouseOver: '',
    },
    {
        id: 5,
        title: 'ADM',
        mouseOver: '',
    },
    {
        id: 6,
        title: 'KGSL',
        mouseOver: '',
    },
    {
        id: 7,
        title: 'DG KAM',
        mouseOver: '',
    },
    {
        id: 8,
        title: 'Auftr. DL-P',
        mouseOver: 'Auftrag an AMS zum DL-Paket',
    },
    {
        id: 9,
        title: 'DL+KA >',
        mouseOver: 'DL+Kanzleiauftrag versandt',
    },
    {
        id: 10,
        title: 'DL+KA <',
        mouseOver: 'DL+Kanzleiauftrag von Kunde zurück',
    },
    {
        id: 11,
        title: 'FP-Grdl. abg.',
        mouseOver: 'Projektgrundlagen abgeschlossen',
    },
    {
        id: 12,
        title: 'FP-Def vollst.',
        mouseOver: 'Projektdefintion vollständig',
    },
    {
        id: 13,
        title: 'CIB abg.',
        mouseOver: 'CIB abgeschlossen',
    },
    {
        id: 14,
        title: 'FP-Feischltg.',
        mouseOver: 'Projekt Freischaltung',
    },
    {
        id: 15,
        title: 'Bemerk',
        mouseOver: 'Bemerkung'
    },
]